import { createContext, useContext, useMemo } from 'react';
import { getAppMode } from '../utils/getAppMode';

const AppModeContext = createContext('partner');

export function AppModeProvider({ children }) {
    const mode = useMemo(() => getAppMode(), []);

    return (
        <AppModeContext.Provider value={mode}>
            {children}
        </AppModeContext.Provider>
    );
}

export function useAppMode() {
    return useContext(AppModeContext);
}
